import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { ConstrainedField } from '@shared/models/constrained-field';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ValidationModel } from '@shared/models';
import { createConstrainedModel } from '../../dynamic-editor-base';

@Component({
  selector: 'app-dynamic-list',
  templateUrl: './dynamic-list.component.html',
  styleUrls: ['./dynamic-list.component.scss']
})
export class DynamicListComponent implements OnInit {
  @Input() public field!: ConstrainedField;
  @Input() public extraData!: DynamicListExtraData;

  ngOnInit() {
    if (this.extraData.data) {
      this.extraData.data.forEach(row => {
        this.addNewRow(row);
      })
    }
  }

  addNewRow(data?: any) {
    let mainFormArray = this.field.control as FormArray;
    let newFormGroup = this.createRowControls(data);
    mainFormArray.push(newFormGroup);
  }

  deleteRow(idx: number) {
    let mainFormArray = this.field.control as FormArray;
    mainFormArray.removeAt(idx);
    this.field.dynamicListRowConstrainedFields.splice(idx, 1);

    mainFormArray.updateValueAndValidity();
  }

  createRowControls(data?: any): FormGroup {
    let sortVM: ValidationModel = {
      field: "sort",
      fType: "numeric",
      fHide: true,
      fEditable: true,
      fMandatory: false,
    }

    let sort = this.field.dynamicListRowConstrainedFields.length;
    data = data ? { ...data, sort } : { sort };

    let rowControls: Record<string, AbstractControl> = {};
    let constrainedFields: ConstrainedField[] = createConstrainedModel([sortVM, ...this.extraData.validationModel], data);

    constrainedFields.forEach(cf => {
      rowControls[cf.key] = cf.control;
    });

    this.field.dynamicListRowConstrainedFields.push(constrainedFields.filter(cf => !cf.hidden));
    return new FormGroup(rowControls);
  }

  drop(event: CdkDragDrop<ConstrainedField[]>) {
    moveItemInArray(this.field.dynamicListRowConstrainedFields, event.previousIndex, event.currentIndex);
    moveItemInArray((this.field.control as FormArray).controls, event.previousIndex, event.currentIndex);
    (this.field.control as FormArray).controls.forEach((control: FormGroup, idx) => {
      control.get('sort').setValue(idx);
    })
  }
}

export interface DynamicListExtraData {
  data?: any;
  validationModel: ValidationModel[];
}
